<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qTPFYO/tc-custom/9780253057556.jpg?1733108845522" alt="This image is the cover for the book Gendering Modern Jewish Thought, New Jewish Philosophy and Thought"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gendering Modern Jewish Thought, New Jewish Philosophy and Thought
      </h1>
      <p class="bookDescription body article font2">
        <p>The idea of brotherhood has been an important philosophical concept for understanding community, equality, and justice. In <i>Gendering Modern Jewish Thought</i>, Andrea Dara Cooper offers a gendered reading that challenges the key figures of the all-male fraternity of twentieth-century Jewish philosophy to open up to the feminine.</p><p>Cooper offers a feminist lens, which when applied to thinkers such as Franz Rosenzweig and Emmanuel Levinas, reveals new ways of illuminating questions of relational ethics, embodiment, politics, and positionality. She shows that patriarchal kinship as models of erotic love, brotherhood, and paternity are not accidental in Jewish philosophy, but serve as norms that have excluded women and non-normative individuals.</p><p><i>Gendering Modern Jewish Thought</i> suggests these fraternal models do real damage and must be brought to account in more broadly humanistic frameworks. For Cooper, a more responsible and ethical reading of Jewish philosophy comes forward when it is opened to the voices of mothers, sisters, and daughters.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrea Dara Cooper
      </h2>
      
      <p class="authorDescription body article"><P>Andrea Dara Cooper is Leonard and Tobee Kaplan Scholar in Modern Jewish Thought and Culture and Associate Professor in the Department of Religion at the University of North Carolina, Chapel Hill. Her work has appeared in the <I>Journal of Jewish Thought and Philosophy</I>, <I>Oxford Bibliographies in Jewish Studies</I>, <I>Religion Compass </I>and the <I>Journal of Jewish Ethics</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0279e7ca